import React from "react";
import './WhiteBlock.css'

const WhiteBlock = (props)=>{
    return(
        <div className={`white-block ${props.positiont}`}></div>
    )
}

export default WhiteBlock;